import { Routes, Route } from 'react-router-dom';
import {
  LayoutDashboard, Users, ClipboardList, FileText, Receipt, MessageSquareWarning,
  Inbox, BookOpen, Banknote, Bell,
} from 'lucide-react';
import PortalLayout, { type NavItem } from '../../components/PortalLayout';

import Dashboard from './Dashboard';
import Staff from './Staff';
import Assignments from './Assignments';
import Reports from './Reports';
import Expenses from './Expenses';
import Bills from './Bills';
import Complaints from './Complaints';
import Meetings from './Meetings';
import Requests from './Requests';
import StaffBook from './StaffBook';
import NoticeBoard from '../Admin/NoticeBoard';
import Profile from '../../components/Profile';

const navItems: NavItem[] = [
  { to: '/manager', label: 'Dashboard', icon: <LayoutDashboard className="h-5 w-5" />, end: true },
  { to: '/manager/staff', label: 'Staff', icon: <Users className="h-5 w-5" /> },
  { to: '/manager/assignments', label: 'Assignments', icon: <ClipboardList className="h-5 w-5" /> },
  { to: '/manager/reports', label: 'Site Report', icon: <FileText className="h-5 w-5" /> },
  { to: '/manager/complaints', label: 'Residents Complaint', icon: <MessageSquareWarning className="h-5 w-5" /> },
  { to: '/manager/expenses', label: 'Site Expenses', icon: <Receipt className="h-5 w-5" /> },
  { to: '/manager/bills', label: 'Bills', icon: <Banknote className="h-5 w-5" /> },
  { to: '/manager/meetings', label: 'Meetings', icon: <LayoutDashboard className="h-5 w-5" /> },
  { to: '/manager/requests', label: 'Request', icon: <Inbox className="h-5 w-5" /> },
  { to: '/manager/staff-book', label: 'Staff Book', icon: <BookOpen className="h-5 w-5" /> },
  { to: '/manager/notices', label: 'Notices', icon: <Bell className="h-5 w-5" /> },
];

export default function Manager() {
  return (
    <PortalLayout title="Manager Portal" navItems={navItems}>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="staff" element={<Staff />} />
        <Route path="assignments" element={<Assignments />} />
        <Route path="reports" element={<Reports />} />
        <Route path="complaints" element={<Complaints />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="bills" element={<Bills />} />
        <Route path="meetings" element={<Meetings />} />
        <Route path="requests" element={<Requests />} />
        <Route path="staff-book" element={<StaffBook />} />
        <Route path="notices" element={<NoticeBoard />} />
        <Route path="profile" element={<Profile />} />
      </Routes>
    </PortalLayout>
  );
}
